import { configureZodItalian } from 'core';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { Toaster } from './components/ui/Toast';
import { AuthProvider } from './lib/auth';
import { PwaUpdatePrompt } from './lib/pwa';
import { queryClient } from './lib/query';
import { createAppRouter } from './router';

configureZodItalian();

const router = createAppRouter();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster />
        <PwaUpdatePrompt />
      </AuthProvider>
    </QueryClientProvider>
  );
}
